import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AvatarUpdateService {

  constructor() { }
  
  private sendProfileUpdate = new Subject<boolean>();
  
  getProfileUpdate$ = this.sendProfileUpdate.asObservable();

  callProfileUpdate() {
    this.sendProfileUpdate.next(true);
  }

}
